var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentationHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#4B8D6B",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.4C12.6627 16.4 13.2 16.9373 13.2 17.6C13.2 18.2627 12.6627 18.8 12 18.8C11.3373 18.8 10.8 18.2627 10.8 17.6C10.8 16.9373 11.3373 16.4 12 16.4Z",
    fill: "#4B8D6B",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.92 6.4C10.2928 6.4 8.94 7.58514 8.68 9.14C8.62549 9.46618 8.87707 9.76 9.20777 9.76H10.0568C10.3028 9.76 10.5139 9.58639 10.5864 9.35127C10.7492 8.82353 11.2398 8.48 11.92 8.48C12.7888 8.48 13.44 9.01941 13.44 9.76C13.44 10.3498 12.9746 10.8232 12.3504 11.1299C11.5442 11.526 10.72 12.0409 10.72 13.2V13.52C10.72 13.7851 10.9349 14 11.2 14H12.32C12.5851 14 12.8 13.7851 12.8 13.52V13.3241C12.8 12.8425 13.1459 12.5865 13.7785 12.255C14.6792 11.7831 15.52 11.0334 15.52 9.76C15.52 7.82796 13.9028 6.4 11.92 6.4Z",
    fill: "#4B8D6B",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationHelpIcon);
export default __webpack_public_path__ + "static/media/documentationHelpIcon.a02526e378e4823680c080f79259300d.svg";
export { ForwardRef as ReactComponent };